// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"57":"index","121":"podcast","138":"profile","237":"seances","452":"sophrologie","505":"boutique","534":"eft"}[chunkId] + "-legacy." + {"57":"9f705deb","121":"ded71c10","138":"416d6042","237":"d9c221e8","452":"3466fc1f","505":"18556f03","534":"cd99a616"}[chunkId] + ".js";
};